import { render, staticRenderFns } from "./SinglePosterView.vue?vue&type=template&id=1322eebb&scoped=true&"
import script from "./SinglePosterView.vue?vue&type=script&lang=js&"
export * from "./SinglePosterView.vue?vue&type=script&lang=js&"
import style0 from "./SinglePosterView.vue?vue&type=style&index=0&id=1322eebb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1322eebb",
  null
  
)

export default component.exports